"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { useEffect, useState } from 'react'

export const useTaskModalDialogState = (tasks: AutopilotTaskDto[]) => {
  const [isOpen, setIsOpen] = useState(false)
  const [modalTasks, setModalTasks] = useState(tasks)

  useEffect(() => {
    if (!isOpen) {
      setModalTasks(tasks)
    }
  }, [isOpen, tasks])

  const open = (currentTasks: AutopilotTaskDto[]) => {
    setModalTasks(currentTasks)
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
  }

  return {
    close,
    isOpen,
    modalTasks,
    open,
  }
}
